export const OPEN_CHEST = 'OPEN_CHEST';
export const RESTART_GAME = 'RESTART_GAME';
